import React from 'react';

import {
  Container,
  Input,
  Button
} from './styles';

export default function NumericInput(props) {
  return (
    <Container>
      <Button>-</Button>
      <Input
        defaultValue="50"
        {...props}
        type="number"
      />
      <Button>+</Button>
    </Container>
  );
}